import axios from 'axios';
import { BASE_URL } from '../../utils/constant';
/**
 * API MIDDLEWARE - Centralized API Request Handler
 * Pattern: Middleware-based pattern for managing all API calls
 *
 * Flow:
 * 1. Listen for 'api/callBegan' action with url, method, data, params
 * 2. Dispatch onStart reducer to set loading state
 * 3. Make axios request
 * 4. On success: dispatch onSuccess reducer with response data
 * 5. On failure: dispatch onError reducer with error details
 */

// Action type for API calls
export const API_CALL_BEGAN = 'api/callBegan';

// Action creator for API calls
export const apiCallBegan = (payload) => ({
    type: API_CALL_BEGAN,
    payload,
});

// Main middleware function
export const apiMiddleware = (store) => (next) => async (action) => {
    // Only handle apiCallBegan actions
    if (action.type !== API_CALL_BEGAN) {
        return next(action);
    }

    const {
        url,
        method = 'GET',
        data = null,
        params = null,
        onStart,
        onSuccess,
        onError,
        // showGlobalError = true,
    } = action.payload;

    // Dispatch onStart action to set loading state
    if (onStart) {
        store.dispatch({ type: onStart });
    }

    next(action);

    try {
        // Make the API request with axios
        const config = {
            url,
            method,
            baseURL: BASE_URL,
            ...(data && { data }),
            ...(params && { params }),
        };

        // Add auth token if available
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers = {
                Authorization: `${token}`,
            };
        }

        const response = await axios(config);

        // Dispatch onSuccess action with response data
        if (onSuccess) {
            store.dispatch({
                type: onSuccess,
                payload: response.data,
            });
        }

        return response.data;
    } catch (error) {
        // Construct error object with message and code
        const errorObject = {
            errorMessage: error.response?.data?.message || error.message || 'An error occurred',
            errorCode: error.response?.status || 500,
            errorDescription: error.response?.data?.description || error.response?.statusText || 'Unknown error',
        };

        // Dispatch onError action with error details
        if (onError) {
            store.dispatch({
                type: onError,
                payload: errorObject,
            });
        }

        console.error('API Error:', errorObject);
        return null;
    }
};
